// extracted by mini-css-extract-plugin
module.exports = {"user-posts-container":"userPost_user-posts-container__ScWpX","post-list":"userPost_post-list__1MWCG"};